import { render } from "./TripleSystemAnalyticsPage.vue?vue&type=template&id=31d27ec1&scoped=true&ts=true"
import script from "./TripleSystemAnalyticsPage.vue?vue&type=script&lang=ts"
export * from "./TripleSystemAnalyticsPage.vue?vue&type=script&lang=ts"

import "./TripleSystemAnalyticsPage.vue?vue&type=style&index=0&id=31d27ec1&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-31d27ec1"]])

export default __exports__